<template>
    <div class=" index " style="margin: 0 26px;margin-bottom: 0!important;">

        <div class="out_box">
            <div class="inner_box u-f">
                <div class="l_box u-f">
                    <div class="picimgs" :style="'background:url('+user.avatar+')'">
                    </div>
                    <div class="rightinfo">
                        <div class="usernmaes">{{user.username}}</div>
                        <div class="allu">{{datas.mcn_name}} <div class="yrz">已入驻</div>
                        </div>
                    </div>
                </div>
                <div class="gg_box">
                    <div class="gg_t u-f u-ac u-jsb">
                        <div class="l">平台公告</div>
                        <div class="r" @click="goallmsg">查看全部</div>
                    </div>
                    <div class="lists">
                        <div class="l_items u-f u-ac" v-for="(q,index) in xx_list" :key="index">
                            <div class="dian"></div>
                            <div class="g_name">{{q.Activity.activity_title}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="banner_b">
                <el-carousel height="150px">
                    <el-carousel-item v-for="item in 4" :key="item">
                        <h3 class="small">{{ item }}</h3>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="inner_box">
                <div class="hxsj_tit">
                    核心数据
                </div>
            </div> -->
        </div>


    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                datas: '',
                xx_list: [],
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            this.getxx()
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                that.heights = window.innerHeight - 240 + 'px'
                window.onresize = () => {
                    that.heights = window.innerHeight - 240 + 'px'
                }
            },
            begin() {
                this.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/manager/getMcnDetail", {

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.datas = response.data.data
                    })
                    .catch(error => {})
            },
            getxx() {
                this.axios.post('/admin/SystemActivity/index', {
                    page: 1,
                    page_count: 8
                }, {
                    token: true
                }).then(res => {
                    this.xx_list = res.data.data.list
                })
            },
            goallmsg() {
                this.$router.push({
                    name: 'MCN_actmsg_list',
                })
            },
        },

    };
</script>
<style lang="scss" scoped>
    .out_box {
        // padding: 30px;
        background-color: #edf0fa;

        .inner_box {
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 0 0 4px 0 rgba($color: #a3a3a3, $alpha: .1);

            .l_box {
                padding: 20px 35px;
                width: 53%;

                .picimgs {
                    width: 150px;
                    padding-top: 150px;
                    background-size: cover !important;
                    background-repeat: no-repeat !important;
                    background-position: center !important;
                    border-radius: 1px;
                }

                .rightinfo {
                    flex: 1;
                    padding: 10px 40px 0;
                    border-right: 1px solid #e9ecf7;

                    .usernmaes {
                        margin-bottom: 20px;
                        font-size: 20px;
                        font-weight: 600;
                        color: #252631;
                    }

                    .allu {
                        font-size: 16px;
                        display: flex;
                        align-items: center;
                        color: #778ca2;

                        .yrz {
                            display: inline-block;
                            background-color: #5DCA7E;
                            color: #fff;
                            border-radius: 20px;
                            font-size: 12px;
                            padding: 0 5px;
                            margin-left: 15px;
                        }
                    }
                }
            }

            .gg_box {
                flex: 1;

                .gg_t {
                    padding: 30px 68px 20px 40px;

                    .l {
                        font-size: 16px;
                        font-weight: 600;
                        color: #252631;
                    }

                    .r {
                        color: #5473e8;
                        cursor: pointer;
                    }
                }

                .lists {
                    padding: 20px 35px;

                    .l_items {
                        margin-bottom: 2px;
                        color: #778ca2;

                        .dian {
                            width: 5px;
                            height: 5px;
                            border-radius: 50%;
                            background-color: #778ca2;
                        }

                        .g_name {
                            margin-left: 10px;
                        }
                    }
                }

            }
            .hxsj_tit{
                padding: 20px 30px;
                font-size: 18px;
                font-weight: 600;
            }
        }

        .banner_b {
            margin: 30px 0;
            .el-carousel__item h3 {
                color: #475669;
                font-size: 14px;
                opacity: 0.75;
                line-height: 150px;
                margin: 0;
            }

            .el-carousel__item:nth-child(2n) {
                background-color: #99a9bf;
            }

            .el-carousel__item:nth-child(2n+1) {
                background-color: #d3dce6;
            }
        }
    }
</style>